export default __webpack_public_path__ + "static/media/a1-3-5.e91cf8ec.jpg";